<template>
  <div>
    <data-table :service="SiteAdminService"
                :entity="entity"
                :columns="columns"
                :disable-permission-checks="true"
                :goToDetailsOnRowClick="false"
                @on-row-click="onRowClick"
                operations="add,refresh,edit,delete"
                ref="table">
      <div class="d-flex align-items-center" slot="name" slot-scope="{row}">
        <base-avatar :user="row" :src="row.image"/>
        <div class="ml-2 d-flex flex-column">
          <div class="text-capitalize font-weight-bold">
            {{row.given_name.toLowerCase()}}
          </div>
        </div>
      </div>

      <template slot="email" slot-scope="{row}">
        {{row.email}}
      </template>
    </data-table>
  </div>
</template>
<script>
  import SiteAdminService from 'src/services/SiteAdminService';
  import {entities} from 'src/config/routeTypes';


  export default {
    name: 'site-admins',
    data() {
      return {
        SiteAdminService,
        entity: entities.SITE_ADMIN
      }
    },
    computed: {
      columns() {
        return [
          {
            prop: "name",
            label: this.$t('user.list.labels.name'),
            minWidth: "180px",
            sortable: true
          },
          {
            prop: "email",
            label: this.$t('user.list.labels.email'),
            minWidth: "200px",
            sortable: true
          },
          {
            prop: "role_name",
            label: this.$t('user.list.labels.role'),
            minWidth: "180px",
            sortable: true
          },
        ]
      }
    },
    methods: {
      onRowClick(row) {
        this.$router.push(`/settings/site-admins/${row.uuid}?role=${row.role_name}`)
      }
    }
  }
</script>
<style>
</style>
